import { userConstants } from '../_constants'

const INITIAL_STATE = {
  token: null,
  userId: null,
  logged: false,
}

const authReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return Object.assign({}, state, {
        userId: action.payload.user,
        token: action.payload.token,
        logged: true,
      })
    case userConstants.LOGOUT:
      return Object.assign({}, state, {
        userId: null,
        token: null,
        logged: false,
      })
    default:
      return state
  }
}

export default authReducer
